import guest from './rules/guest';
import auth from './rules/auth';
import admin from './rules/admin';

export default {
    guest, auth , admin
}